import { render, staticRenderFns } from "./FlashInformationBlock.vue?vue&type=template&id=70e86bf5&"
import script from "./FlashInformationBlock.vue?vue&type=script&lang=js&"
export * from "./FlashInformationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports